import { Component, OnInit, AfterContentInit, AfterViewInit } from '@angular/core';
import { IdentityService } from '../employment101/services/identity.service';
import { Router } from '@angular/router';

@Component({
  selector: 'casemanagerview',
  templateUrl: './casemanagerview.component.html',
  styleUrls: ['./casemanagerview.component.css'],
  providers: [IdentityService]
})
export class CasemanagerviewComponent implements OnInit {

  caseMngrName: string = "";
  userName: string = "";
  isCaseMngView: boolean = false;

  constructor(private _router: Router, private identitySrv: IdentityService) { }

  ngOnInit() {

    this.identitySrv.getUserGuid().subscribe(usrguid => {

      if (usrguid != null && usrguid != "") {

        this.identitySrv.getCaseManagerInfo().subscribe(resp => {
          if (resp == null) {
            this.isCaseMngView = false;
          } else {
            this.isCaseMngView = true;
            this.caseMngrName = resp.caseMngrName;
            this.userName = resp.userName;
          }
        });

      }
    });

  }

  stopCaseMngrView() {

    if (confirm("Are you sure you want to stop working as " + this.userName + " ?")) {
      this.isCaseMngView = false;
      this.identitySrv.update("");
      this.identitySrv.setUserGuid().subscribe();

      setTimeout(() => {
        let currentUrl = this._router.url;
        this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this._router.navigate([currentUrl]);
        });
      }, 500);

    }
  }

}
